import { Component, Element, Listen, Method, State } from '@stencil/core';

@Component({
  tag: 'mama-collapse',
})
export class MamaCollapse {
  @Element() el!: HTMLElement;
  @State() open = false;
  contentHeight = 0;
  padding = 16;

  numberOfChildren = 0;
  singleItemHeight = 80;

  componentDidLoad() {
    this.getAccordionContentHeight();
  }

  /**
   * Clones accordion content to get its height and removes it after that
   */
  getAccordionContentHeight() {
    if (this.el && this.el.querySelector('.collapse-content')) {
      const content = (this.el.querySelector('.collapse-content') as HTMLElement).cloneNode(true) as HTMLElement;
      content.style.paddingLeft = '1rem';
      content.style.paddingRight = '1rem';
      const container = document.createElement('div');
      container.classList.add('container');
      container.appendChild(content);
      (document.querySelector('body') as HTMLElement).appendChild(container);
      this.contentHeight = (content as HTMLElement).clientHeight + this.padding;
      (content as HTMLElement).querySelectorAll('*').forEach(child => {
        const style = window.getComputedStyle(child as Element);
        let childMargin = parseInt(style.marginBottom) + parseInt(style.marginTop);
        this.contentHeight += childMargin;
      });
      container.remove();
    }
  }

  @Listen('click')
  toggleOpen(event: MouseEvent) {
    const target = event.target as HTMLElement;
    if (target.hasAttribute('role')) {
      event.preventDefault();
    }

    if (
      target.classList.contains('collapse-headline') ||
      target.classList.contains('plus-circle') ||
      target.classList.contains('minus-circle') ||
      target instanceof SVGUseElement
    ) {
      this.setOpen(!this.open);

      if (this.contentHeight !== 0) {
        this.toggleAccordion();
      }
    }
  }

  toggleAccordion() {
    let height = 0;
    if (this.open) {
      height = this.contentHeight;
    }
    const collapseContent = this.el.querySelector('.collapse-content') as HTMLElement;
    if (collapseContent) {
      collapseContent.setAttribute('style', 'max-height:' + height + 'px;');
    }
  }

  @Method()
  async isOpen() {
    return this.open;
  }

  @Method()
  async setOpen(open: boolean) {
    this.open = open;
    this.toggleAccordion();
  }

  hostData() {
    return {
      class: {
        show: this.open,
      },
    };
  }
}
